const now = new Date()
const pad = n => String(n).padStart(2, '0')
const prevMonth =
  now.getMonth() === 0
    ? `${now.getFullYear() - 1}12`
    : `${now.getFullYear()}${pad(now.getMonth())}`

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
export const DEFAULT_MONTH = prevMonth
export const CSV_FILE_PREFIX = 'gs-programwise-invoices'
export const EMPTY_TABLE_TEXT = 'No invoice data. Fetch data to view program-wise invoices.'
export const FETCH_ERROR_MESSAGE = 'Failed to fetch program-wise invoice data'

export const INVOICE_TABLE_COLUMNS = [
  { 
    id: 'account',       
    label: 'Account',          
    sortable: false 
  },
  { 
    id: 'program',       
    label: 'Program' 
  },
  { 
    id: 'month',         
    label: 'Month' 
  },
  { 
    id: 'currency',      
    label: 'Currency' 
  },
  { 
    id: 'totalHits',     
    label: 'Total API Hits' 
  },
  { 
    id: 'freeHits',      
    label: 'Free Hits' 
  },
  { 
    id: 'overageHits',   
    label: 'Average Hits' 
  },
  { 
    id: 'apiOvgFees',    
    label: 'API Average Fees' 
  },
  { 
    id: 'activeSites',   
    label: 'Active Sites' 
  },
  { 
    id: 'billableSites', 
    label: 'Billable Sites' 
  },
  { 
    id: 'sitesFees',     
    label: 'Sites Fees' 
  },
  { 
    id: 'hrtSites',      
    label: 'HRT Sites' 
  },
  { 
    id: 'hrtFees',       
    label: 'HRT Fees' 
  },
  { 
    id: 'fixedFees',     
    label: 'Fixed Fees' 
  },
  { 
    id: 'totalAmount',   
    label: 'Total Amount' 
  },
  { 
    id: 'taxAmount',     
    label: 'Tax Amount' 
  },
  { 
    id: 'totalWithTax',  
    label: 'Total Invoice' 
  },
  { 
    id: 'config',        
    label: 'Config',            
    sortable: false 
  },
]

export const CSV_HEADERS = [
  'Account Name', 'Account ID', 'Program Name', 'Program ID', 'Month', 'Currency',
  'Total API Hits', 'Free Hits', 'Average Hits', 'API Average Fees',
  'Active Sites', 'Billable Sites', 'Sites Fees', 'HRT Sites', 'HRT Fees',
  'Fixed Fees', 'Total Amount', 'Tax Amount', 'Total Invoice', 'Status',
]
